import React from "react";
import configData from '../../config/config.json';
import './index.css';
import Modal from 'react-responsive-modal';
import MuiDialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';

import Cookies from 'universal-cookie';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import Slide from '@material-ui/core/Slide';

//Set the styles
const Dialog = withStyles(() => ({
    paper: { 
        minWidth: "350px",
        padding: '.5em' },
  }))(MuiDialog);
  
const DialogContent = withStyles((theme) => ({
    root: {
      /*padding: theme.spacing(0),
      textAlign: 'center'*/
    },
}))(MuiDialogContent);

const DialogTitle = withStyles((theme) => ({
    root: {
      margin: 0,
      padding: 0,


    },
}))(MuiDialogTitle);


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

const cookies = new Cookies();
class Promotion extends React.Component {

    constructor (props) {
        super(props)
        this.state = {
            open_promotion: this.props?.show?true:false
        }

        //binding
        this.showPromotionModal = this.showPromotionModal.bind(this);
    }

    showPromotionModal = (event, open) => {
        console.log(event)
        console.log(open)
        if (event)
            event.stopPropagation()

        //console.log(open)
        this.setState({ 
            open_promotion: open,
            open: false
         });

         if  (open==false) {
            cookies.set(this.props.campaign,true,{ 
                path: '/' ,
                maxAge: 1 // 10 = 10 sec, 4 hour = 60*60*4
              })
         }
    };

    render() {
        const { t } = this.props;
        let content = (<></>);

        if (this.props?.campaign==='independence-day-2025' && window.location.pathname=='/') {
            content = (
                <Dialog
                    open={this.state.open_promotion && !cookies.get(this.props.campaign)} 
                    onClose={(e) => this.showPromotionModal(e,false)}
                    direction="rtl"
                    minWidth="xl"
                    style={{minWidth:'325px', padding:0}}
                    scroll="paper"
                    TransitionComponent={Transition}
                    sx={{
                        "& .MuiDialog-container": {
                          "& .MuiPaper-root": {
                            width: "100%",
                            maxWidth: "500px",  // Set your width here
                          },
                        },
                      }}
                    >
                    <DialogTitle>
                        <button tabIndex={0}
                         style={{border:'none', background:'none'}}
                         title={t('promotions.generic.hideAd')}
                         onClick={e=>{this.showPromotionModal(e, false)}} >
                        <FontAwesomeIcon icon={faTimes} size="1x" style={{color:'#000', cursor:'pointer'}}/>
                    </button>
                    </DialogTitle>
                    <DialogContent
                        style={{padding:'0 !important'}}
                    >

                        <div dir="rtl" id="modal_content" style={{color:'#000', fontWeight:'600', display:'none', padding:'0 1em'}} tabIndex={0}>
                            <p><h4><strong>{t('promotions.campaigns.independenceDay2025.title')}</strong>
                            <p>{t('promotions.campaigns.independenceDay2025.description')}</p></h4>
                            </p>

                            <h5><strong>{t('promotions.campaigns.independenceDay2025.howToGetCoupon.title')}</strong></h5>
                            <p dangerouslySetInnerHTML={{__html: t('promotions.campaigns.independenceDay2025.howToGetCoupon.step1')}}></p>
                            <p dangerouslySetInnerHTML={{__html: t('promotions.campaigns.independenceDay2025.howToGetCoupon.step2')}}></p>


                            <h5><strong>{t('promotions.campaigns.independenceDay2025.howToUseCoupon.title')}</strong></h5>
                            <p>{t('promotions.campaigns.independenceDay2025.howToUseCoupon.description')}</p>


                            <h5><strong>{t('promotions.campaigns.independenceDay2025.terms.title')}</strong></h5>
                            <p>
                            {t('promotions.campaigns.independenceDay2025.terms.description')}
                            </p>

                            <center><button tabIndex={0} title={t('promotions.generic.understood')} onClick={(e) => this.showPromotionModal(e,false)}>{t('promotions.generic.understood')}</button></center>

                        </div>

                        <a href="#" title={t('promotions.campaigns.independenceDay2025.imageAlt')} id="popup_img" onClick={(e)=> {
                                window.document.getElementById('popup_img').style.display = 'none'
                                window.document.getElementById('modal_content').style.display = 'inherit'
                            }} >
                                <img
                                    tabIndex={0}
                                    src="/images/promotions/independence-day-2025/image.png"
                                    alt={t('promotions.campaigns.independenceDay2025.imageAlt')}
                                    style={{border:'2px solid #000', maxWidth:'100%'}}
                                    border="0" />
                            </a>
                    </DialogContent>
                </Dialog>

                            
            )
        }

        if (this.props?.campaign==='shoppingil2025' && window.location.pathname=='/') {
            content = (
                <Dialog
                    open={this.state.open_promotion && !cookies.get(this.props.campaign)} 
                    onClose={(e) => this.showPromotionModal(e,false)}
                    direction="rtl"
                    minWidth="xl"
                    style={{minWidth:'325px', padding:0}}
                    scroll="paper"
                    TransitionComponent={Transition}
                    sx={{
                        "& .MuiDialog-container": {
                          "& .MuiPaper-root": {
                            width: "100%",
                            maxWidth: "500px",  // Set your width here
                          },
                        },
                      }}
                    >
                    <DialogTitle>
                        <button tabIndex={0}
                         style={{border:'none', background:'none'}} 
                         title={t('promotions.generic.hideAd')}
                         onClick={e=>{this.showPromotionModal(e, false)}} >
                        <FontAwesomeIcon icon={faTimes} size="1x" style={{color:'#000', cursor:'pointer'}}/>
                    </button>
                    </DialogTitle>
                    <DialogContent
                        style={{padding:'0 !important'}}
                    >
                    
                        <div dir="rtl" id="modal_content" style={{color:'#000', fontWeight:'600', display:'none', padding:'0 1em'}} tabIndex={0}>
                            <p><h4><strong>{t('promotions.campaigns.shoppingil2025.title')}</strong>
                            <p>{t('promotions.campaigns.shoppingil2025.description')}</p></h4>
                            </p>

                            <h5><strong>{t('promotions.campaigns.shoppingil2025.howItWorks.title')}</strong></h5>
                            <p>{t('promotions.campaigns.shoppingil2025.howItWorks.step1')}</p>
                            <p>{t('promotions.campaigns.shoppingil2025.howItWorks.step2')}</p>


                            <h5><strong>{t('promotions.campaigns.shoppingil2025.terms.title')}</strong></h5>
                            <p dangerouslySetInnerHTML={{__html: t('promotions.campaigns.shoppingil2025.terms.description')}}>
                            </p>
                            
                            <center><button tabIndex={0} title={t('promotions.generic.understood')} onClick={(e) => this.showPromotionModal(e,false)}>{t('promotions.generic.understood')}</button></center>

                        </div>
                    
                        <a href="#" title={t('promotions.campaigns.shoppingil2025.imageTitle')} id="popup_img" onClick={(e)=> {
                                window.document.getElementById('popup_img').style.display = 'none'
                                window.document.getElementById('modal_content').style.display = 'inherit'
                            }} >
                                <img 
                                    tabIndex={0}
                                    src="/images/promotions/shoppingil2025/popup.png" 
                                    alt={t('promotions.campaigns.shoppingil2025.imageAlt')} 
                                    style={{border:'2px solid #000', maxWidth:'100%'}} 
                                    border="0" />
                            </a>
                    </DialogContent>
                </Dialog>

                            
            )
        }

                if (this.props?.campaign==='blackfriday2025' && window.location.pathname=='/') {
            content = (
                <Dialog
                    open={this.state.open_promotion && !cookies.get(this.props.campaign)} 
                    onClose={(e) => this.showPromotionModal(e,false)}
                    direction="rtl"
                    minWidth="xl"
                    style={{minWidth:'325px', padding:0}}
                    scroll="paper"
                    TransitionComponent={Transition}
                    sx={{
                        "& .MuiDialog-container": {
                          "& .MuiPaper-root": {
                            width: "100%",
                            maxWidth: "500px",  // Set your width here
                          },
                        },
                      }}
                    >
                    <DialogTitle>
                        <button tabIndex={0}
                         style={{border:'none', background:'none'}} 
                         title={t('promotions.generic.hideAd')}
                         onClick={e=>{this.showPromotionModal(e, false)}} >
                        <FontAwesomeIcon icon={faTimes} size="1x" style={{color:'#000', cursor:'pointer'}}/>
                    </button>
                    </DialogTitle>
                    <DialogContent
                        style={{padding:'0 !important'}}
                    >
                    
                        <div dir="rtl" id="modal_content" style={{color:'#000', fontWeight:'600', display:'none', padding:'0 1em'}} tabIndex={0}>
                            <p><h4><strong>{t('promotions.campaigns.blackfriday2025.title')}</strong>
                            <p>{t('promotions.campaigns.blackfriday2025.description')}</p></h4>
                            </p>

                            <h5><strong>{t('promotions.campaigns.blackfriday2025.howItWorks.title')}</strong></h5>
                            <p>{t('promotions.campaigns.blackfriday2025.howItWorks.step1')}</p>
                            <p>{t('promotions.campaigns.blackfriday2025.howItWorks.step2')}</p>


                            <h5><strong>{t('promotions.campaigns.blackfriday2025.terms.title')}</strong></h5>
                            <p dangerouslySetInnerHTML={{__html: t('promotions.campaigns.blackfriday2025.terms.description')}}>
                            </p>
                            
                            <center><button tabIndex={0} title={t('promotions.generic.understood')} onClick={(e) => this.showPromotionModal(e,false)}>{t('promotions.generic.understood')}</button></center>

                        </div>
                    
                        <a href="#" title={t('promotions.campaigns.blackfriday2025.imageTitle')} id="popup_img" onClick={(e)=> {
                                window.document.getElementById('popup_img').style.display = 'none'
                                window.document.getElementById('modal_content').style.display = 'inherit'
                            }} >
                                <img 
                                    tabIndex={0}
                                    src="/images/promotions/blackfriday2025/popup.png" 
                                    alt={t('promotions.campaigns.blackfriday2025.imageAlt')} 
                                    style={{border:'2px solid #000', maxWidth:'100%'}} 
                                    border="0" />
                            </a>
                    </DialogContent>
                </Dialog>

                            
            )
        }

        if (this.props?.campaign==='blackfriday2025' && window.location.pathname=='/') {
            content = (
                <Dialog
                    open={this.state.open_promotion && !cookies.get(this.props.campaign)} 
                    onClose={(e) => this.showPromotionModal(e,false)}
                    direction="rtl"
                    minWidth="xl"
                    style={{minWidth:'325px', padding:0}}
                    scroll="paper"
                    TransitionComponent={Transition}
                    sx={{
                        "& .MuiDialog-container": {
                          "& .MuiPaper-root": {
                            width: "100%",
                            maxWidth: "500px",  // Set your width here
                          },
                        },
                      }}
                    >
                    <DialogTitle>
                        <button tabIndex={0}
                         style={{border:'none', background:'none'}} 
                         title={t('promotions.generic.hideAd')}
                         onClick={e=>{this.showPromotionModal(e, false)}} >
                        <FontAwesomeIcon icon={faTimes} size="1x" style={{color:'#000', cursor:'pointer'}}/>
                    </button>
                    </DialogTitle>
                    <DialogContent
                        style={{padding:'0 !important'}}
                    >
                    
                        <div dir="rtl" id="modal_content" style={{color:'#000', fontWeight:'600', display:'none', padding:'0 1em'}} tabIndex={0}>
                            <p><h4><strong>{t('promotions.campaigns.blackfriday2025.title')}</strong>
                            <p>{t('promotions.campaigns.blackfriday2025.description')}</p></h4>
                            </p>

                            <h5><strong>{t('promotions.campaigns.blackfriday2025.howItWorks.title')}</strong></h5>
                            <p>{t('promotions.campaigns.blackfriday2025.howItWorks.step1')}</p>
                            <p>{t('promotions.campaigns.blackfriday2025.howItWorks.step2')}</p>


                            <h5><strong>{t('promotions.campaigns.blackfriday2025.terms.title')}</strong></h5>
                            <p dangerouslySetInnerHTML={{__html: t('promotions.campaigns.blackfriday2025.terms.description')}}>
                            </p>
                            
                            <center><button tabIndex={0} title={t('promotions.generic.understood')} onClick={(e) => this.showPromotionModal(e,false)}>{t('promotions.generic.understood')}</button></center>

                        </div>
                    
                        <a href="#" title={t('promotions.campaigns.blackfriday2025.imageTitle')} id="popup_img" onClick={(e)=> {
                                window.document.getElementById('popup_img').style.display = 'none'
                                window.document.getElementById('modal_content').style.display = 'inherit'
                            }} >
                                <img 
                                    tabIndex={0}
                                    src="/images/promotions/blackfriday2025/popup.png" 
                                    alt={t('promotions.campaigns.blackfriday2025.imageAlt')} 
                                    style={{border:'2px solid #000', maxWidth:'100%'}} 
                                    border="0" />
                            </a>
                    </DialogContent>
                </Dialog>

                            
            )
        }

        if (this.props?.campaign==='spa' && window.location.pathname=='/') {
            content = (
                <Dialog
                    open={this.state.open_promotion && !cookies.get(this.props.campaign)} 
                    onClose={(e) => this.showPromotionModal(e,false)}
                    direction="rtl"
                    minWidth="xl"
                    style={{minWidth:'325px'}}
                    scroll="paper"
                    TransitionComponent={Transition}
                    sx={{
                        "& .MuiDialog-container": {
                          "& .MuiPaper-root": {
                            width: "100%",
                            maxWidth: "500px",  // Set your width here
                          },
                        },
                      }}
                    >
                    <DialogTitle>
                        <button tabIndex={0}
                         style={{border:'none', background:'none'}} 
                         title={t('promotions.generic.hideAd')}
                         onClick={e=>{this.showPromotionModal(e, false)}} >
                        <FontAwesomeIcon icon={faTimes} size="1x" style={{color:'#000', cursor:'pointer'}}/>
                    </button>
                    </DialogTitle>
                    <DialogContent
                        style={{padding:'0 1.25em 1.25em 1.25em'}}
                    >
                    
                        <div dir="rtl" id="modal_content" style={{color:'#000', fontWeight:'600', display:'none', padding:'1em'}} tabIndex={0}>
                            <p><h4><strong>{t('promotions.campaigns.spa.title')}</strong></h4>
                            </p>

                            <p>{t('promotions.campaigns.spa.description')}</p>
                            <p><h5><strong>{t('promotions.campaigns.spa.howToRedeem.title')}</strong></h5>
                            {t('promotions.campaigns.spa.howToRedeem.description')}</p>
                            <p>
                            <h5><strong>{t('promotions.campaigns.spa.terms.title')}</strong></h5>
                            {t('promotions.campaigns.spa.terms.description')}
                            </p>
                            <center><button tabIndex={0} title={t('promotions.generic.understood')} onClick={(e) => this.showPromotionModal(e,false)}>{t('promotions.generic.understood')}</button></center>

                        </div>
                    
                        <a href="#" title={t('promotions.campaigns.spa.imageTitle')} id="popup_img" onClick={(e)=> {
                                window.document.getElementById('popup_img').style.display = 'none'
                                window.document.getElementById('modal_content').style.display = 'inherit'
                            }} >
                                <img 
                                    tabIndex={0}
                                    src="/images/promotions/spa/image.jpg" 
                                    alt={t('promotions.campaigns.spa.imageAlt')} 
                                    style={{border:'2px solid #000'}} 
                                    border="0" />
                            </a>
                    </DialogContent>
                </Dialog>

                            
            )
        }

        if (this.props?.campaign==='coupon-50') {
            content = (
                
                <Modal 
                    open={this.state.open_promotion && !cookies.get(this.props.campaign)} onClose={(e) => this.showPromotionModal(e,false)}
                    center 
                    blockScroll={true}
                    closeIcon={<><FontAwesomeIcon icon={faTimes} size="1x" style={{color:'#000', cursor:'pointer'}}/></>}
                    animationDuration={1000}
                    style={{maxWidth:'300px', padding:0, flexDirection:'reverse'}} 
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    closeAfterTransition
                    >
                    <a href="https://wa.link/vzatw1">
                        <img src="/images/promotions/coupon-50/image.jpg" alt={t('promotions.campaigns.coupon50.imageAlt')} style={{width:'100%',border:'none', marginTop:'1.5em'}} border="0"></img>
                    </a>
                </Modal>
                            
            )
        }

        if (this.props?.campaign==='crazyweekend') {
            content = (
                <div className={this.props?.hide?'hidden':'PromotionBox'}  onClick={(e) => this.showPromotionModal(e, true)}>
                    <div className="subtitle_item" >
                        <div className="icons_wrapper" style={{maxHeight:'unset', padding:0, background:'inherit'}}>
                        <div className="icons_content" style={{}}>
                            <img src="/images/promotions/crazyweekend/card.png" style={{width:'85px'}} alt={t('promotions.campaigns.crazyweekend.imageAlt')}></img>
                            <Modal open={this.state.open_promotion} onClose={(e) => this.showPromotionModal(e,false)} center >
                                <div dir="rtl"  className="modal_content" style={{color:'#000', fontWeight:'600'}}>
                                    <p><br /><strong>{t("promotions.campaigns.crazyweekend.modal.title")}</strong><br /><br />
                                    {t("promotions.campaigns.crazyweekend.modal.intro")}
                                    </p>

                                    <p>{t("promotions.campaigns.crazyweekend.modal.description")}</p>
                                    <p>{t("promotions.campaigns.crazyweekend.modal.instructions")}</p>
                                    <p>{t("promotions.campaigns.crazyweekend.modal.terms")}</p>

                                </div>
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>
            )
        }
        
        if (this.props?.campaign==='weekend30') {
            content= (
                <div className={this.props?.hide?'hidden':'PromotionBox'}  onClick={(e) => this.showPromotionModal(e, true)}>
                    <div className="subtitle_item" >
                        <div className="icons_wrapper" style={{maxHeight:'unset', padding:0, background:'inherit'}}>
                        <div className="icons_content" style={{}}>
                            <img src="/images/promotions/weekend30/card.png" style={{width:"85px"}} alt={t("promotions.campaigns.weekend30.imageAlt")}></img>
                            <Modal open={this.state.open_promotion} onClose={(e) => this.showPromotionModal(e,false)} center >
                                <div dir="rtl"  className="modal_content" style={{color:'#000', fontWeight:'600'}}>
                                    <p><br /><strong>{t("promotions.campaigns.weekend30.modal.title")}</strong><br /><br />
                                    {t("promotions.campaigns.weekend30.modal.intro")}
                                    </p>

                                    <p>{t("promotions.campaigns.weekend30.modal.description")}</p>
                                    <p>{t("promotions.campaigns.weekend30.modal.instructions")}</p>
                                    <p>{t("promotions.campaigns.weekend30.modal.terms")}</p>

                                </div>
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>
            )
        } 
        
        if (this.props?.campaign==='rosh25') {
            content= (
                <div className={this.props?.hide?'hidden':'PromotionBox'}  onClick={(e) => this.showPromotionModal(e, true)}>
                    <div className="subtitle_item" >
                        <div className="icons_wrapper" style={{maxHeight:'unset', padding:0, background:'inherit'}}>
                        <div className="icons_content" style={{}}>
                            <img src="/images/promotions/rosh25/card.png" style={{width:"85px"}} alt={t("promotions.campaigns.rosh25.imageAlt")}></img>
                            <Modal open={this.state.open_promotion} onClose={(e) => this.showPromotionModal(e,false)} center >
                                <div dir="rtl"  className="modal_content" style={{color:'#000', fontWeight:'600'}}>
                                    <p><br /><strong>{t("promotions.campaigns.rosh25.modal.title")}</strong><br />
                                    </p>

                                    <p>{t("promotions.campaigns.rosh25.modal.description")}</p>
                                    <p>{t("promotions.campaigns.rosh25.modal.instructions")}</p>
                                    <p>{t("promotions.campaigns.rosh25.modal.terms")}</p>

                                </div>
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>
            )
        }

        return content;
        
        
    }

}
export default withTranslation()(Promotion);
